<template>
  <td data-int="cart-cell-name">
    <template v-if="item.partUnavailable">
      <strong>{{ $t('notAvailable') }}</strong>
    </template>
    <template v-else>
      <router-link :to="{ path: uri }">
        <strong>{{ item.name }}</strong>
      </router-link>
    </template>
    <br/>
    {{ item.partNumber }}
  </td>
</template>

<script>
export default {
  name: 'CartCellName',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    uri() {
      return `/part/${this.item.partId}`;
    }
  }
};
</script>

<style scoped>

</style>
